import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IMedicalExamCertificateRestrictionType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class MedicalExamCertificateRestrictionType implements IMedicalExamCertificateRestrictionType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    get WearingCorrectiveLenses(): IMedicalExamCertificateRestrictionType {
        return this.FromId(1);
    }

    get WearingHearingAid(): IMedicalExamCertificateRestrictionType {
        return this.FromId(2);
    }

    get AccompaniedbyWaiverExemption(): IMedicalExamCertificateRestrictionType {
        return this.FromId(3);
    }

    get DrivingWithinAnExemptIntracityZone(): IMedicalExamCertificateRestrictionType {
        return this.FromId(4);
    }

    get AccompaniedByASkillPerformanceExaminationCertificate(): IMedicalExamCertificateRestrictionType {
        return this.FromId(5);
    }

    get QualifiedByOperationOf49CFR391_64(): IMedicalExamCertificateRestrictionType {
        return this.FromId(6);
    }

    get GrandfatheredFromStateRequirements(): IMedicalExamCertificateRestrictionType {
        return this.FromId(7);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, active: true, value: 'WearingCorrectiveLenses', displayValue: '1 - Wearing Corrective Lenses', description: 'Wearing Corrective Lenses', sotOrder: 99999 });
        this._dictionary.add('2', { id: 2, active: true, value: 'WearingHearingAid', displayValue: '2 - Wearing Hearing Aid', description: 'Wearing Hearing Aid', sotOrder: 99999 });
        this._dictionary.add('3', { id: 3, active: true, value: 'AccompaniedByWaiverExemption', displayValue: '3 - Accompanied by Waiver/Exemption', description: 'Accompanied by Waiver Exemption', sotOrder: 99999 });
        this._dictionary.add('4', { id: 4, active: true, value: 'DrivingWithinAnExemptIntracityZone', displayValue: '4 - Driving within an exempt intracity zone', description: 'Driving within an exempt intracity zone', sotOrder: 99999 });
        this._dictionary.add('5', { id: 5, active: true, value: 'AccompaniedByASkillPerformanceExaminationCertificate', displayValue: '5 - Accompanied by a Skill Performance Examination Certificate (SPE)', description: 'Accompanied by a Skill Performance Examination Certificate (SPE)', sotOrder: 99999 });
        this._dictionary.add('6', { id: 6, active: true, value: 'QualifiedByOperationOf49CFR391_64', displayValue: '6 - Qualified by operation of 49 CFR 391.64', description: 'Qualified by operation of 49 CFR 391.64', sotOrder: 99999 });
        this._dictionary.add('7', { id: 7, active: true, value: 'GrandfatheredFromStateRequirements', displayValue: '7 - Grandfathered from State Requirements', description: 'Grandfathered from State Requirements', sotOrder: 99999 });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IMedicalExamCertificateRestrictionType {
        return this._dictionary[id];
    }

    public FromValue = (value: string): IMedicalExamCertificateRestrictionType => {
        var match = this._dictionary.getValues().filter(data =>  data.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    };

    public GetAll = (): IMedicalExamCertificateRestrictionType[] => this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));

    public GetActive = (): IMedicalExamCertificateRestrictionType[] => this.GetAll().filter(data => data.active);

    public Sort = (primaryField, secondaryField, reverse): IMedicalExamCertificateRestrictionType[] => this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
